/**
 * Enum representing the different types of documents required for Afriex Know Your Business (KYB) verification.
 * Each document type serves a specific purpose in the business verification process.
 */
export var BusinessKYBDocumentType;
(function (BusinessKYBDocumentType) {
    /**
     * Represents the type of business.
     *
     * Values:
     * Individual (Sole Proprietor / Trader)
     * Partnership (General / Limited / LLP)
     * Company (Ltd / LLC / C-Corp / Pvt Ltd / PLC)
     * NGO / Non-Profit
     * Cooperative
     * Governmental or Public Sector
     */
    BusinessKYBDocumentType["BusinessType"] = "BUSINESS_TYPE";
    /**
     * Represents documentation describing the nature and activities of the business,
     * used to understand the type of services or products offered.
     */
    BusinessKYBDocumentType["BusinessNature"] = "BUSINESS_NATURE";
    /**
     * Represents an official business identification number or tax registration number
     * that uniquely identifies the business with government authorities.
     */
    BusinessKYBDocumentType["BusinessNumber"] = "BUSINESS_NUMBER";
    /**
     * Represents a website URL that serves as proof of the business's online presence
     * and operational legitimacy.
     */
    BusinessKYBDocumentType["BusinessWebsite"] = "BUSINESS_WEBSITE";
    /**
     * Represents the physical location of a business,
     * typically including street address, city, and country information.
     */
    BusinessKYBDocumentType["BusinessAddress"] = "BUSINESS_ADDRESS";
    /**
     * Represents a document verifying the BusinessAddress.
     */
    BusinessKYBDocumentType["ProofOfBusinessAddress"] = "PROOF_OF_BUSINESS_ADDRESS";
    /**
     * Represents an official business registration or incorporation certificate,
     * used to verify the legal existence of a business entity.
     */
    BusinessKYBDocumentType["BusinessCertificate"] = "BUSINESS_CERTIFICATE";
    /**
     * Represents an official business articles of incorporation document.
     */
    BusinessKYBDocumentType["ArticlesDocument"] = "ARTICLES_DOCUMENT";
    /**
     * Represents an official business shareholder registry document.
     */
    BusinessKYBDocumentType["ShareholderRegistry"] = "SHAREHOLDER_REGISTRY";
    /**
     * Represents the approximate monthly volume of transactions or services provided by the business in USD
     */
    BusinessKYBDocumentType["BusinessVolume"] = "BUSINESS_VOLUME";
})(BusinessKYBDocumentType || (BusinessKYBDocumentType = {}));
//# sourceMappingURL=BusinessKYBDocumentType.js.map